import { FC, ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { EIconSize } from 'utils/constants/app/ui';
import { ResultsGame, ResultsSport } from 'interfaces/results';
import { SportsMenu } from './__partials/SportsMenu';
import { GlobalIcon } from 'components/GlobalIcon';
import { addQuery } from 'components/QueryRoute';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useSortFavoriteSportsOrdering } from 'hooks/sportsbook/useSortFavoriteSportsOrdering';
import { useSearchParams } from 'hooks/useSearchParams';
import {
  resetFilters,
  setCurrentStatus,
  setSport,
  setTrigger
} from 'store/actions/results-data';
import { getResultsData, getResultsSport } from 'store/selectors/results-data';
import { Games } from '../../components/Games';
import { GeneralFilter } from '../../components/GeneralFilter';
import './index.less';

type Props = {
  games: ResultsGame[] | null;
  loading: boolean;
};

export const ResultsMobileView: FC<Props> = ({
  games,
  loading
}): ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { game_id: gameId } = useSearchParams();

  const history = useHistory();
  const resultsDataRedux = useSelector(getResultsData);
  const resultsData = useSortFavoriteSportsOrdering(resultsDataRedux, 'Id');
  const resultsSport = useSelector(getResultsSport);
  const [selectedSportInfo, setSelectedSportInfo] =
    useState<ResultsSport | null>(null);

  const [filtersOpen, setFiltersOpen] = useState(false);

  useEffect(() => {
    dispatch(setCurrentStatus());

    if (!resultsSport && resultsData) {
      if (resultsData[0]) {
        dispatch(setSport(resultsData[0].Id));
      }

      dispatch(setTrigger());
    }

    setSelectedSportInfo(
      resultsData?.find(fullSport => fullSport.Id === resultsSport) || null
    );
  }, [resultsSport, resultsData]);

  return (
    <div className="results">
      <SportsMenu
        sports={resultsData?.map(fullSport => ({
          Id: fullSport.Id,
          Name: fullSport.Name,
          Alias: fullSport.Alias
        }))}
        onSelect={(id: number) => {
          gameId && history.push(addQuery({ game_id: undefined }));

          dispatch(resetFilters());
          dispatch(setSport(id));
          dispatch(setTrigger());
        }}
        selectedSport={resultsSport}
      />
      <div className="results__header">
        <div className="results__headerSportName">
          {selectedSportInfo?.Name || (
            <Skeleton
              title={{ style: { width: 100, height: 12, margin: 0 } }}
              active
              paragraph={false}
            />
          )}
        </div>
        <div
          className="results__filterButton"
          onClick={() => setFiltersOpen(prev => !prev)}
        >
          {t('sportsbook.sportFilter')}
          {filtersOpen ? (
            <GlobalIcon
              lib="generic"
              name="closeFill"
              theme="default"
              size={EIconSize._16}
              className="results__close-icon"
            />
          ) : (
            <GlobalIcon
              lib="generic"
              name="filterEdit"
              theme="default"
              className="results__filter-icon"
              size={EIconSize._16}
            />
          )}
        </div>
      </div>
      {filtersOpen ? <GeneralFilter gameId={gameId} vertical /> : null}
      <div className="results__games__wrapper">
        <Games games={games} loading={loading} gameId={gameId} />
      </div>
    </div>
  );
};
